import React from 'react';
import { useSelector } from 'react-redux';

import BreederProfileMoreAboutBreederItemsContainer from '../BreederProfileMoreAboutBreederItemsContainer';
import BreederProfileTrustedCardContainer from '../BreederProfileTrustedCardContainer';

export default function BreederProfileMoreAboutBreederSectionContainer() {
  const { breederFirstName } = useSelector(({ server }) => server);

  return (
    <div className="BreederProfileMoreAboutBreederSectionContainer container-xxl mv12 mv20-md">
      <h2 className="font-24 md:font-40 lh-title mb10 mb12-md">
        More about {breederFirstName}
      </h2>
      <div className="grid lg:grid-cols-2 gap-48 lg:gap-96 items-start">
        <BreederProfileMoreAboutBreederItemsContainer />
        <BreederProfileTrustedCardContainer />
      </div>
    </div>
  );
}
